import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import MetaTags from 'react-meta-tags';
import SweetAlert from 'react-bootstrap-sweetalert';
import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import BtnLoader from '../../components/Loaders/btnLoader';

import Select from 'react-select';
import makeAnimated from 'react-select/animated';
//Calendar
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import BootstrapTheme from '@fullcalendar/bootstrap';
import '@fullcalendar/bootstrap/main.css';
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Alert
} from 'reactstrap';
import {
  getMeetings,
  addMeeting,
  updateMeeting,
  deleteMeeting
} from '../../store/meeting/actions';
import PageLoader from '../../components/Loaders/pageLoader';
//Import Breadcrumb
import Breadcrumbs from '../../components/Breadcrumb';
import { Notification } from '../../components/Notifications/notifications';

const animatedComponents = makeAnimated();

class MeetingsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      meetings: [],
      modal: false,
      alert: null,
      selectedMulti: null,
      timeOptions: [
        { value: '7:30', time: '7:30', disabled: false },
        { value: '8:0', time: '8:00', disabled: false },
        { value: '8:30', time: '8:30', disabled: false },
        { value: '9:0', time: '9:00', disabled: false },
        { value: '9:30', time: '9:30', disabled: false },
        { value: '10:0', time: '10:00', disabled: false },
        { value: '10:30', time: '10:30', disabled: false },
        { value: '11:0', time: '11:00', disabled: false },
        { value: '11:30', time: '11:30', disabled: false },
        { value: '12:0', time: '12:00', disabled: false },
        { value: '12:30', time: '12:30', disabled: false },
        { value: '13:0', time: '13:00', disabled: false },
        { value: '13:30', time: '13:30', disabled: false },
        { value: '14:0', time: '14:00', disabled: false },
        { value: '14:30', time: '14:30', disabled: false },
        { value: '15:0', time: '15:00', disabled: false },
        { value: '15:30', time: '15:30', disabled: false },
        { value: '16:00', time: '16:00', disabled: false },
        { value: '16:30', time: '16:30', disabled: false },
        { value: '17:00', time: '17:00', disabled: false },
        { value: '17:30', time: '17:30', disabled: false },
        { value: '18:00', time: '18:00', disabled: false }
      ]
    };
    this.handleDateClick = this.handleDateClick.bind(this);
    this.handleEventClick = this.handleEventClick.bind(this);
    this.handleValidMeetingSubmit = this.handleValidMeetingSubmit.bind(this);
    this.handleDeleteEvent = this.handleDeleteEvent.bind(this);
    this.deleteMeetingAlert = this.deleteMeetingAlert.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.toggle = this.toggle.bind(this);
    this.handleMultiSelect = this.handleMultiSelect.bind(this);
    this.disableTakenTime = this.disableTakenTime.bind(this);
    this.sortUsersByDepartments = this.sortUsersByDepartments.bind(this);
  }
  componentDidMount() {
    const { onGetMeetings } = this.props;
    onGetMeetings();
  }

  /**
   * Handling the modal state
   */
  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal
    }));
  }
  handleMultiSelect = (selectedMulti) => {
    this.setState({ selectedMulti });
  };
  sortUsersByDepartments = () => {
    const { users, departments } = this.props;
    let userOptions = [];
    departments.map((department) => {
      userOptions.push({
        label: department.depName,
        options: []
      });
      return userOptions;
    });
    for (var i = 0; i < userOptions.length; i++) {
      for (var j = 0; j < users.length; j++) {
        if (userOptions[i]['label'] === users[j]['department']['depName']) {
          userOptions[i]['options'].push({
            label: users[j]['fname'] + ' ' + users[j]['sname'],
            value: users[j]['workEmail'],
            bitrixID: users[j]['bitrixID']
          });
        }
      }
    }
    this.setState({ userOptions });
  };
  disableTakenTime = (date) => {
    const { meetings } = this.props;
    let timeOptions = [
      { value: '7:30', time: '7:30', disabled: false },
      { value: '8:0', time: '8:00', disabled: false },
      { value: '8:30', time: '8:30', disabled: false },
      { value: '9:0', time: '9:00', disabled: false },
      { value: '9:30', time: '9:30', disabled: false },
      { value: '10:0', time: '10:00', disabled: false },
      { value: '10:30', time: '10:30', disabled: false },
      { value: '11:0', time: '11:00', disabled: false },
      { value: '11:30', time: '11:30', disabled: false },
      { value: '12:0', time: '12:00', disabled: false },
      { value: '12:30', time: '12:30', disabled: false },
      { value: '13:0', time: '13:00', disabled: false },
      { value: '13:30', time: '13:30', disabled: false },
      { value: '14:0', time: '14:00', disabled: false },
      { value: '14:30', time: '14:30', disabled: false },
      { value: '15:0', time: '15:00', disabled: false },
      { value: '15:30', time: '15:30', disabled: false },
      { value: '16:0', time: '16:00', disabled: false },
      { value: '16:30', time: '16:30', disabled: false },
      { value: '17:0', time: '17:00', disabled: false },
      { value: '17:30', time: '17:30', disabled: false },
      { value: '18:0', time: '18:00', disabled: false }
    ];
    let takenTime = [];
    meetings.map((meeting) => {
      if (
        new Date(meeting.start).toLocaleDateString('en-GB') ===
        new Date(date).toLocaleDateString('en-GB')
      ) {
        let startH = parseInt(new Date(meeting.start).toLocaleTimeString('en-GB').split(':')[0]);
        let startM = parseInt(new Date(meeting.start).toLocaleTimeString('en-GB').split(':')[1]);
        let endH = parseInt(new Date(meeting.end).toLocaleTimeString('en-GB').split(':')[0]);
        let endM = parseInt(new Date(meeting.end).toLocaleTimeString('en-GB').split(':')[1]);
        if (startH + ':' + startM !== endH + ':' + endM) {
          if (startM === 30) {
            takenTime.push(startH + ':' + startM);
            startH++;
          }
          for (let i = startH; i < endH; i++) {
            takenTime.push(i < 10 ? '0' + i + ':00' : i + ':00');
            takenTime.push(i < 10 ? '0' + i + ':30' : i + ':30');
          }
          takenTime.push(endH + ':00');
          if (endM === 30) takenTime.push(endH + ':30');
        } else {
          takenTime.push(startH + ':' + startM);
        }
      }
      return takenTime;
    });
    for (let i = 0; i < timeOptions.length; i++) {
      for (let j = 0; j < takenTime.slice(0, -1).length; j++) {
        if (timeOptions[i]['time'] === takenTime[j]) {
          timeOptions[i]['disabled'] = true;
        }
      }
    }
    this.setState({ timeOptions });
  };
  /**
   * Handling date click on calendar
   */
  handleDateClick = (arg) => {
    const { profileData } = this.props;
    const date = arg['date'];
    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();

    const currentDate = new Date();
    const currentHour = currentDate.getHours();
    const currentMin = currentDate.getMinutes();
    const currentSec = currentDate.getSeconds();
    const modifiedDate = new Date(year, month, day, currentHour, currentMin, currentSec);
    const modifiedData = { ...arg, date: modifiedDate };

    this.disableTakenTime(date);
    this.sortUsersByDepartments();

    this.setState({
      selectedDay: modifiedData,
      isEdit: false,
      event: [],
      selectedMulti: [
        {
          label: profileData.fname + ' ' + profileData.sname,
          value: profileData.workEmail,
          bitrixID: profileData.bitrixID
        }
      ]
    });
    this.toggle();
  };
  /**
   * Handling click on event on calendar
   */
  handleEventClick = (arg) => {
    const event = arg.event;
    const start = new Date(event.start);
    const startHour = start.getHours();
    const startMin = start.getMinutes();
    const modifiedStart = startHour + ':' + startMin;

    const end = new Date(event.end);
    const endtHour = end.getHours();
    const endMin = end.getMinutes();
    const modifiedEnd = endtHour + ':' + endMin;
    const modifiedDate = { dateStr: start.toLocaleDateString('fr-CA') };
    this.disableTakenTime(modifiedDate.dateStr);
    this.sortUsersByDepartments();
    this.setState({
      event: {
        id: event._def.extendedProps._id,
        title: event.title,
        start: modifiedStart,
        end: modifiedEnd,
        className: event.classNames,
        bookedBy: event._def.extendedProps.bookedBy._id,
        sendReminder: event._def.extendedProps.sendReminder,
        manager:
          event._def.extendedProps.bookedBy.fname +
          ' ' +
          event._def.extendedProps.bookedBy.sname
      },
      selectedDay: modifiedDate,
      selectedMulti: event._def.extendedProps.participants,
      isEdit: true
    });
    this.toggle();
  };
  /**
   * Handling submit event on event form
   */
  handleValidMeetingSubmit = (e, values) => {
    const { onAddMeeting, onUpdateMeeting, profileData } = this.props;
    const { isEdit, event, selectedDay, selectedMulti } = this.state;
    const start_date = new Date(selectedDay.dateStr + ' ' + values['start']);
    const end_date = new Date(selectedDay.dateStr + ' ' + values['end']);
    if (isEdit) {
      const updateEvent = {
        _id: event.id,
        title: values.eventName,
        start: start_date,
        end: end_date,
        bookedBy: profileData._id,
        bookedByName: profileData.fname + ' ' + profileData.sname,
        bookedByBID: profileData.bitrixID,
        participants: selectedMulti,
        sendReminder: values.sendReminder,
        // status: 'update',
        module: 'Bot Booking Meeting Notification',
        option: 'updateMeeting',
        classNames: 'bg-success text-white'
      };
      // update event
      onUpdateMeeting(updateEvent);
    } else {
      const newMeeting = {
        title: values['eventName'],
        start: start_date,
        end: end_date,
        bookedBy: profileData._id,
        bookedByName: profileData.fname + ' ' + profileData.sname,
        bookedByBID: profileData.bitrixID,
        participants: selectedMulti,
        sendReminder: values['sendReminder'],
        // module: 'new',
        module: 'Bot Booking Meeting Notification',
        option: 'newMeeting',
        className: 'bg-success text-white'
      };
      // save new event
      onAddMeeting(newMeeting);
    }
    // this.setState({ selectedDay: null, isEdit: false });
    this.toggle();
  };
  /**
   * On delete event
   */
  handleDeleteEvent = () => {
    const getAlert = () => (
      <SweetAlert
        danger
        showCancel
        confirmBtnText='Yes, delete it!'
        confirmBtnBsStyle='danger'
        title='Are you sure?'
        onConfirm={() => this.deleteMeetingAlert(this.state.event.id)}
        onCancel={this.hideAlert}
        focusCancelBtn
      >
        Meeting will be deleleted
      </SweetAlert>
    );
    this.setState({
      alert: getAlert()
    });
  };
  /**
   * @returns set state of alert to null
   */
  hideAlert = () => this.setState({ alert: null });
  /**
   * Function to delete an order from table and hide alert
   * @param {array} battle
   */
  deleteMeetingAlert = (id) => {
    const { onDeleteMeeting } = this.props;
    onDeleteMeeting(id);
    this.toggle();
    this.hideAlert();
  };
  render() {
    const { meetings, profileData } = this.props;
    const { isEdit, timeOptions, userOptions, selectedMulti } = this.state;
    return (
      <React.Fragment>
        {this.props.loading && <PageLoader />}
        <div className='page-content'>
          <MetaTags>
            <title>Meeting Room Booking </title>
          </MetaTags>
          <Container fluid>
            {profileData.role !== 'Outsider' && profileData.country === 'my' ? (
              <>
                {/* Render Breadcrumbs */}
                <Breadcrumbs title='Korupharma' breadcrumbItem='Meeting Room Booking' />
                <Card>
                  <CardBody>
                    <Row id='card-section'>
                      <Col md={8}>
                        {/* fullcalendar control */}
                        <FullCalendar
                          ref={this.calendarComponentRef}
                          plugins={[BootstrapTheme, dayGridPlugin, interactionPlugin]}
                          slotDuration={'00:30:00'}
                          handleWindowResize={true}
                          displayEventEnd={true}
                          themeSystem='bootstrap'
                          headerToolbar={{
                            left: 'prev,next today',
                            center: 'title',
                            right: 'dayGridMonth,dayGridWeek,dayGridDay'
                          }}
                          events={meetings}
                          editable={true}
                          droppable={true}
                          selectable={true}
                          weekends={false}
                          dateClick={this.handleDateClick}
                          eventClick={this.handleEventClick}
                          drop={this.onDrop}
                        />

                        {/* New/Edit event modal */}
                        <Modal
                          isOpen={this.state.modal}
                          className={this.props.className}
                          id='event-modal'
                          toggle={this.toggle}
                        >
                          <ModalHeader toggle={this.toggle} tag='h4'>
                            {!!isEdit
                              ? 'Edit Booking Made By ' + this.state.event.manager
                              : 'Add Booking'}
                          </ModalHeader>
                          <ModalBody>
                            <AvForm
                              onValidSubmit={this.handleValidMeetingSubmit}
                              ref={(c) => (this.form = c)}
                            >
                              <Row>
                                <Col md={12}>
                                  <FormGroup className='mb-3'>
                                    <AvField
                                      name='eventName'
                                      label='Booking Name'
                                      type='text'
                                      errorMessage='Invalid name'
                                      disabled={
                                        !!isEdit &&
                                        this.state.event.bookedBy !== profileData._id &&
                                        true
                                      }
                                      validate={{
                                        required: { value: true }
                                      }}
                                      value={this.state.event ? this.state.event.title : ''}
                                    />
                                  </FormGroup>
                                  {/* {this.state.event && this.state.event.start} */}
                                  {/* {this.state.event && this.state.event.end} */}
                                </Col>
                              </Row>
                              <Row>
                                <Col md={6}>
                                  <FormGroup className='mb-4'>
                                    <AvField
                                      type='select'
                                      name='start'
                                      className='form-select'
                                      label='Time Start'
                                      errorMessage='Please select time start'
                                      disabled={
                                        !!isEdit &&
                                        this.state.event.bookedBy !== profileData.workEmail &&
                                        true
                                      }
                                      validate={{
                                        required: {
                                          value: true
                                        }
                                      }}
                                      value={this.state.event ? this.state.event.start : ''}
                                    >
                                      <option>Select Time Start</option>
                                      {timeOptions.map((option, id) => {
                                        return (
                                          <option
                                            key={id}
                                            value={option.value}
                                            disabled={option.disabled}
                                          >
                                            {option.time}
                                          </option>
                                        );
                                      })}
                                      {/* <option value='7:30'>7:30</option>
                                      <option value='8:0'>8:00</option>{' '}
                                      <option value='8:30'>8:30</option>{' '}
                                      <option value='9:0'>9:00</option>{' '}
                                      <option value='9:30'>9:30</option>{' '} */}
                                    </AvField>
                                  </FormGroup>
                                </Col>
                                <Col md={6}>
                                  <FormGroup className='mb-4'>
                                    <AvField
                                      type='select'
                                      name='end'
                                      className='form-select'
                                      label='Time End'
                                      errorMessage='Please select time end'
                                      disabled={
                                        !!isEdit &&
                                        this.state.event.bookedBy !== profileData._id &&
                                        true
                                      }
                                      validate={{
                                        required: {
                                          value: true
                                        }
                                      }}
                                      value={this.state.event ? this.state.event.end : ''}
                                    >
                                      <option>Select Time End</option>
                                      {timeOptions.map((option, id) => {
                                        return (
                                          <option
                                            key={id}
                                            value={option.value}
                                            disabled={option.disabled}
                                          >
                                            {option.time}
                                          </option>
                                        );
                                      })}
                                    </AvField>
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={12}>
                                  <FormGroup className='mb-3'>
                                    <Select
                                      value={selectedMulti}
                                      isMulti={true}
                                      onChange={this.handleMultiSelect}
                                      options={userOptions}
                                      classNamePrefix='select2-selection'
                                      closeMenuOnSelect={false}
                                      components={animatedComponents}
                                      isDisabled={
                                        !!isEdit &&
                                        this.state.event.bookedBy !== profileData._id &&
                                        true
                                      }
                                      name='usersSelected'
                                      id='usersSelected'
                                    />
                                  </FormGroup>
                                  {/* {this.state.event && this.state.event.start} */}
                                  {/* {this.state.event && this.state.event.end} */}
                                </Col>
                              </Row>
                              <Row>
                                <Col md={12}>
                                  <FormGroup className='mb-3 font-size-14'>
                                    <AvField
                                      name='sendReminder'
                                      type='checkbox'
                                      label='Remind me 10 mins before the meeting'
                                      className='form-check-input'
                                      disabled={
                                        !!isEdit &&
                                        this.state.event.bookedBy !== profileData._id &&
                                        true
                                      }
                                      value={this.state.event ? this.state.event.sendReminder : ''}
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col>
                                  <div className='text-end'>
                                    {this.props.loading && <BtnLoader />}
                                    <button
                                      type='button'
                                      className='btn btn-light me-2'
                                      onClick={this.toggle}
                                    >
                                      Close
                                    </button>
                                    {!!isEdit &&
                                      this.state.event.bookedBy === profileData._id && (
                                        <button
                                          type='button'
                                          className='btn btn-danger me-2'
                                          onClick={() => this.handleDeleteEvent()}
                                        >
                                          Delete
                                        </button>
                                      )}
                                    <button type='submit' className='btn btn-success save-event'>
                                      Save
                                    </button>
                                  </div>
                                </Col>
                              </Row>
                            </AvForm>
                          </ModalBody>
                        </Modal>
                        {this.state.alert}
                      </Col>
                      <Col md={4} className='text-left'>
                      <Notification compData={meetings} keyWord='meeting' module='Bot Booking Meeting Notification' />
                        <div className='snote'>
                          <ul>
                            <li>
                              <a href='#LINK 1'>
                                <h2>Rule #1</h2>
                                <hr />
                                <p>Book the space ahead of time and stick to the schedule.</p>
                              </a>
                            </li>
                            <li>
                              <a href='#LINK 2'>
                                <h2>Rule #2</h2>
                                <hr />
                                <p>Cancel early if there is a need to reschedule.</p>
                              </a>
                            </li>
                            <li>
                              <a href='#LINK 3'>
                                <h2>Rule #3</h2>
                                <hr />
                                <p>
                                  Priority will be given to those who have booked the room earlier
                                  (first come first serve).
                                </p>
                              </a>
                            </li>
                            <li>
                              <a href='#LINK 4'>
                                <h2>Rule #4</h2>
                                <hr />
                                <p>
                                  If you want to book for 30 minutes, just select the same Time
                                  Start and Time End.
                                </p>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </>
            ) : (
              <Alert color='danger'> You do not have access to this page. </Alert>
            )}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

MeetingsList.propTypes = {
  meetings: PropTypes.array,
  onGetMeetings: PropTypes.func,
  // onGetUsers: PropTypes.func,
  // onGetDepartments: PropTypes.func,
  onAddMeeting: PropTypes.func,
  onUpdateMeeting: PropTypes.func,
  onDeleteMeeting: PropTypes.func
};

const mapStateToProps = ({ meetings }) => ({
  meetings: meetings.meetings,
  users: meetings.users,
  departments: meetings.departments,
  loading: meetings.loading
});

const mapDispatchToProps = (dispatch) => ({
  onGetMeetings: () => dispatch(getMeetings()),
  // onGetUsers: () => dispatch(getUsers()),
  // onGetDepartments: () => dispatch(getDepartments()),
  onAddMeeting: (meetings) => dispatch(addMeeting(meetings)),
  onUpdateMeeting: (meetings) => dispatch(updateMeeting(meetings)),
  onDeleteMeeting: (meetings) => dispatch(deleteMeeting(meetings))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MeetingsList));
